import find from 'lodash/find';

export function arrayed(value) {
    if(typeof value == 'undefined') { return []; }
    return (value instanceof Array) ? value : [value];
}

export function findOrFail(arr, predicate) {
    let findResult = find(arr, predicate);

    if(typeof findResult === 'undefined') {
        let msg = `Failed to find ${JSON.stringify(predicate)}`;

        // console.error(msg+' in', arr);
        throw new Error(msg);
    }

    return findResult;
}

export function pushUniqStr(arr, str) {
    if(arr.indexOf(str) > -1) {
        return;
    }

    return arr.push(str);
}

export function pushUniqStrs(arr, strs) {
    for(let str of strs) {
       pushUniqStr(arr, str)
    }
}